/* =========================================================================
   Staff-only gate for the floating AI assistant.

   Students shouldn't see the orb at all — only admins and testers do. Gating
   here rather than inside <AiAssistant> means the component never mounts for
   everyone else: no effects, no AI calls, nothing in the DOM to find.

   It's a separate component because App renders <UserAuthContextProvider>, so
   App itself sits above the context and can't read the signed-in user.

   Privilege is client-side only, the same trust model as the rest of the app
   (see utils/roles.js) — this hides the tool, it does not secure the /codenec
   AI endpoints.

   This is one of THREE guards that must agree. This one decides whether the
   assistant exists; DemoNavbar and LessonNavBar each render an #ai-robot-dock
   socket the orb snaps into, and a socket with no orb to fill it shows up as a
   bare empty circle. Change the role rule here, change it in both navbars.
   ========================================================================= */

import { useUserAuth } from "../../context/UserContext.js";
import { isPrivilegedRole } from "../../utils/roles.js";
import AiAssistant from "./AiAssistant.js";

const AiAssistantGate = (props) => {
  const { user } = useUserAuth();

  if (!isPrivilegedRole(user?.role)) return null;

  return <AiAssistant {...props} />;
};

export default AiAssistantGate;
